import {
  defFetchList,
  defFetchOne,
  defUpdateOne,
  defCreate
} from '@/api/default'

const BASE_PATH = '/soa/note'

export function fetchList (query) {
  return defFetchList(BASE_PATH, query)
}

export function fetchOne (id) {
  return defFetchOne(BASE_PATH, id)
}

export function updateOne (id, data) {
  return defUpdateOne(BASE_PATH, id, data)
}

export function create (data) {
  return defCreate(BASE_PATH, data)
}

export function createByEditBookings (data) {
  return defCreate(BASE_PATH + '/edit-bookings', data)
}
